module.exports = __webpack_public_path__ + "static/media/list1-.a0fb79d0.jpg";